import { asyncScheduler, OperatorFunction, Subject } from 'rxjs';
import { delay, multicast, refCount, retryWhen, tap } from 'rxjs/operators';

/** Delays the stream for one iteration of the event loop, then monitors the next iteration for repeated failures. */
export function retryDelay<T>(): OperatorFunction<T, T> {
  let isRetrying = false;

  const retries$ = new Subject();
  retries$.subscribe(() => {
    isRetrying = true;
  });
  retries$.pipe(delay(0, asyncScheduler)).subscribe(() => {
    isRetrying = false;
  });

  return retryWhen(errors$ =>
    errors$.pipe(
      tap(error => {
        // Our retry failed, so give up.
        if (isRetrying) {
          throw error;
        }

        // eslint-disable-next-line no-console
        console.error('Caught error in editor side effects stream:', error);
      }),
      delay(0, asyncScheduler),
      multicast(retries$),
      refCount(),
    ),
  );
}
